<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  *ngIf="!isMobileDevice()"
  class="nvs-margin-custom nvs-total"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="1rem"
>
  <div class="nvs-width-28" fxLayoutAlign="start start">
    <mat-icon
      class="place-self-center ws-cursor-pointer notranslate"
      (click)="backToHome()"
      svgIcon="arrow_back"
    >
    </mat-icon>
    <img
      (click)="backToHome()"
      class="whiteshop-logo ws-cursor-pointer"
      [src]="whiteShopIcon"
      alt="whiteShopIcon"
    />
  </div>
  <div class="nvs-text-big nvc-font-weight-normal nvs-width-28">
    Check your email for a code
  </div>
  <div class="nvs-text-medium nvc-font-weight-normal nvs-width-28">
    We sent a six digit code <b>{{ resendCode }}</b> to
    {{ userData.data.user.username }} that will expire shortly, so please enter
    it soon
  </div>
  <div
    class="nvs-width-28"
    fxLayout="row"
    fxLayoutAlign="space-evenly center"
    fxLayoutGap="1em"
    [formGroup]="otpForm"
  >
    <input
      #box1
      formControlName="box1"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(1)"
      (focus)="onFocusEvent(1)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
    <input
      #box2
      formControlName="box2"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(2)"
      (focus)="onFocusEvent(2)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
    <input
      #box3
      formControlName="box3"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(3)"
      (focus)="onFocusEvent(3)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
    <input
      #box4
      formControlName="box4"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(4)"
      (focus)="onFocusEvent(4)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
    <input
      #box5
      formControlName="box5"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(5)"
      (focus)="onFocusEvent(5)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
    <input
      #box6
      formControlName="box6"
      class="nvs-input-otp border-focus-blue"
      type="number"
      (input)="onKeyUpFunction(6)"
      (focus)="onFocusEvent(6)"
      (paste)="onPasteOtp($event)"
      min="0"
      max="9"
    />
  </div>
  <div fxLayoutAlign="start start" class="nvs-width-28">
    <button
      id="resendotp"
      class="button-clear border-focus-blue nvs-text-blue ws-cursor-pointer"
      (click)="resendOtp()"
    >
      Resend Code <b>{{ resendCode }}</b>
    </button>
  </div>
  <div class="nvs-width-28">
    <button
      fxLayoutAlign="center center"
      id="verifyotp"
      [disabled]="!otpForm.valid"
      [ngClass]="{
        'nvc-disabled ws-no-cursor-pointer': !otpForm.valid
      }"
      class="nvs-button-register button-shadow-focus ws-cursor-pointer nvc-uppercase"
      (click)="verifyOtp()"
    >
      Submit
    </button>
  </div>
  <div
    class="nvs-text-terms nvc-position-absolute nvc-font-weight-normal nvs-width-28"
  >
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>

<div
  *ngIf="isMobileDevice()"
  fxLayout="column"
  fxLayoutAlign="space-between center"
  class="nvs-margin-custom nvs-total"
>
  <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    fxLayoutGap="3rem"
  >
    <div class="nvs-width-25" fxLayoutAlign="start start">
      <mat-icon
        class="place-self-center ws-cursor-pointer notranslate"
        (click)="backToHome()"
        svgIcon="arrow_back"
      >
      </mat-icon>
      <img
        (click)="backToHome()"
        class="whiteshop-logo ws-cursor-pointer"
        [src]="whiteShopIcon"
        alt="whiteShopIcon"
      />
    </div>
    <div
      fxLayout="column"
      fxLAyoutAlign="space-between center"
      fxLayoutGap="40px"
    >
      <div class="nvs-text-bold nvs-width-25">Check your email for a code</div>
      <div
        class="nvs-text-small nvc-font-weight-normal nvs-color-grey nvs-width-25"
      >
        We sent a six digit code
        <span class="nvc-color-black">{{ resendCode }}</span> to
        <span class="nvc-color-black">{{ userData.data.user.username }} </span>
        that will expire shortly, so please enter it soon
      </div>
      <div
        class="nvs-width-25"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="1em"
        [formGroup]="otpForm"
      >
        <input
          #box1
          formControlName="box1"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(1)"
          (focus)="onFocusEvent(1)"
          min="0"
          max="9"
        />
        <input
          #box2
          formControlName="box2"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(2)"
          (focus)="onFocusEvent(2)"
          min="0"
          max="9"
        />
        <input
          #box3
          formControlName="box3"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(3)"
          (focus)="onFocusEvent(3)"
          min="0"
          max="9"
        />
        <input
          #box4
          formControlName="box4"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(4)"
          (focus)="onFocusEvent(4)"
          min="0"
          max="9"
        />
        <input
          #box5
          formControlName="box5"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(5)"
          (focus)="onFocusEvent(5)"
          min="0"
          max="9"
        />
        <input
          #box6
          formControlName="box6"
          class="nvs-input-otp border-focus-blue"
          type="number"
          (input)="onKeyUpFunction(6)"
          (focus)="onFocusEvent(6)"
          min="0"
          max="9"
        />
      </div>
      <div fxLayout="column" fxLayoutGap="20px">
        <div class="nvs-width-25 nvc-margin-top">
          <button
            id="resendotp"
            class="button-clear border-focus-blue nvs-text-blue ws-cursor-pointer"
            (click)="resendOtp()"
          >
            Resend Code <b>{{ resendCode }}</b>
          </button>
        </div>
        <div class="nvs-width-25">
          <button
            *ngIf="otpForm.valid"
            fxLayoutAlign="center center"
            id="verifyotp"
            [disabled]="!otpForm.valid"
            [ngClass]="{
              'nvc-disabled ws-no-cursor-pointer': !otpForm.valid
            }"
            class="nvs-button-register button-shadow-focus ws-cursor-pointer nvc-uppercase"
            (click)="verifyOtp()"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="nvs-text-terms nvc-position-relative nvc-font-weight-normal nvs-width-25"
  >
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>

<!-- <div
  fxLayout="column"
  fxLayoutAlign="start center"
  class="nvc-total"
  [formGroup]="otpForm"
  fxLayoutGap="10px"
  (keyup.enter)="submit()"
>
  <div
    fxLayout="row"
    class="nvc-width-hundred nvc-position-sticky"
    fxLayoutAlign="space-between center"
    fxLayoutGap="1em"
  >
    <div class="nvc-margin-left">
      <h3>Verification</h3>
    </div>
    <div>
      <mat-icon class="ws-cursor-pointer nvc-close" (click)="backToHome()"
        >close</mat-icon
      >
    </div>
  </div>
  <div class="nvc-total-width" fxLayout="column" fxLayoutAlign="center center">
    <div>OTP has been sent to</div>
    <div class="nvc-username-color">{{ userData.data.user.username }}</div>
  </div>
  <div class="nvc-input-div" fxLayout="column">
    <input
      id="otpfield"
      type="text"
      placeholder="Enter OTP"
      class="nvc-input"
      formControlName="otp"
      required
    />
    <div fxLayout>
      <div *ngIf="this.otpForm.invalid && otpForm.controls['otp'].touched && otpForm.controls['otp'].dirty">
        <small id="invalidotp" class="nvc-red">* Enter Valid OTP</small>
      </div>
    </div>
  </div>
  <div class="nvc-input-div">
    <button
      id="verifyotp"
      class="nvs-button-register ws-cursor-pointer"
      (click)="verifyOtp()"
      [disabled]="this.otpForm.invalid"
      [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': this.otpForm.invalid }"
    >
      <b>VERIFY OTP</b>
    </button>
  </div>

  <div id="resendotp" class="nvs-register-store-footer ws-cursor-pointer" (click)="resendOtp()">
    <b>Resend OTP</b>

    For e2e Testing purpose
    <div>
      <p id="hiddenOtp" style="font-size: 0">{{ userData.data.otp }}</p>
    </div>
  </div>
</div> -->
